import { render, staticRenderFns } from "./HistoryFilterLink.vue?vue&type=template&id=4c3931f7&scoped=true&"
import script from "./HistoryFilterLink.vue?vue&type=script&lang=js&"
export * from "./HistoryFilterLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3931f7",
  null
  
)

export default component.exports